function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M32 0c17.7 0 32 14.3 32 32S49.7 64 32 64 0 49.7 0 32 14.3 0 32 0z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M29 16h6l-1 20h-4z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 44,
  r: 4,
  fill: "#fff"
});

function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNjQgNjQiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxwYXRoIGQ9Ik0zMiwwYzE3LjcsMCwzMiwxNC4zLDMyLDMyUzQ5LjcsNjQsMzIsNjRTMCw0OS43LDAsMzJTMTQuMywwLDMyLDB6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cG9seWdvbiBwb2ludHM9IjI5IDE2IDM1IDE2IDM0IDM2IDMwIDM2IiBmaWxsPSIjZmZmIi8+PGNpcmNsZSBjeD0iMzIiIGN5PSI0NCIgcj0iNCIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==";
export { SvgError as ReactComponent };